import { vec2 } from "gl-matrix";

/**
 * Distance between two points.
 * @param {vec2} a
 * @param {vec2} b
 * @returns {number}
 */
export const distance = (a, b) => vec2.distance(a, b);

/**
 * Point halfway between two points.
 * @param {vec2} a
 * @param {vec2} b
 * @returns {vec2}
 */
export const midpoint = (a, b) => vec2.lerp(vec2.create(), a, b, 0.5);

/**
 * Mean of any number of points.
 * @param {vec2[]} points - At least one.
 * @returns {vec2}
 */
export const centroid = (points) => {
  const sum = vec2.create();
  for (const point of points) vec2.add(sum, sum, point);
  return vec2.scale(sum, sum, 1 / points.length);
};
